import React, { useEffect } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./RedeemRequests.module.sass";
import Card from "../Card";
import Icon from "../Icon";
import { UseApi } from "../../hooks/use-api";
import { GetRedeemList } from "../../Services/lib/admin";
import home from "../../i11/Home";
import { useUser } from "../../context";
import { templateProcessor } from "../../Services/assets/template-processor";

const requests = [
	{
		content:
			'You have <strong>0 open redeem requests</strong> to action. This includes <strong>0 new requests</strong>. <span role="img" aria-label="smile">👀</span>',
		icon: "basket",
		fill: "#FF6A55",
		color: "#FFE7E4",
	},
];

const RedeemRequests = ({ className }) => {
	const { locale } = useUser();
	const [{ data }, fetch] = UseApi({
		service: GetRedeemList,
	});

	useEffect(() => {
		fetch({
			redeemType: "REDEEM_REQUESTED",
			isCount: true,
		});
	}, []);

	if (!data) return <div />;
	return (
		<Card
			className={cn(styles.card, className)}
			title={home[locale].redeem_requests}
			classTitle="title-green"
		>
			<div className={styles.section}>
				<div className={styles.list}>
					{requests.map((x, index) => (
						<div className={styles.item} key={"tmpee" + index}>
							<div
								className={styles.icon}
								style={{ backgroundColor: x.color }}
							>
								<Icon name={x.icon} size="24" fill={x.fill} />
							</div>
							{data && (
								<div
									className={styles.content}
									dangerouslySetInnerHTML={{
										__html: templateProcessor(
											{ count: data || 0 },

											home[locale].redeem_text
										),
									}}
								></div>
							)}
						</div>
					))}
				</div>
				<Link
					className={cn("button-stroke", styles.button)}
					to="/products/redeem"
				>
					{home[locale].review_requests}
				</Link>
			</div>
		</Card>
	);
};

export default RedeemRequests;
